import { useCatalogLabelMap } from '@/hooks/useCatalog';

type Props = {
  value: number;
  onChange: (level: number) => void;
};

export default function DifficultySelector({ value, onChange }: Props) {
  const labels = useCatalogLabelMap('Difficulty');
  return (
    <div className="flex gap-2">
      {[1, 2, 3, 4, 5].map((level) => (
        <button
          key={level}
          type="button"
          onClick={() => onChange(level)}
          className={`flex flex-1 flex-col items-center gap-1 rounded-lg border px-2 py-3 text-sm transition-colors ${
            value === level
              ? 'border-primary bg-primary/10 text-primary font-semibold'
              : 'border-border text-muted-foreground hover:border-primary/40 hover:bg-muted'
          }`}
        >
          <span className="text-lg font-bold">{level}</span>
          <span className="text-[10px] leading-tight">{labels.get(String(level)) ?? String(level)}</span>
        </button>
      ))}
    </div>
  );
}
